export const MAX_FILE_SIZE = 50000
export const MAX_FILE_NAME_LENGTH = 40
export const LIMIT_TEXT = '50 MB'
export const GENERIC_ERROR = 'There was a problem with uploading your file. Please try again.'
export const LIMIT_ERROR = `Your file is over the ${LIMIT_TEXT} limit`
